import {
  Menu as MantineMenu,
  type MenuProps as MantineMenuProps,
} from '@mantine/core';
import type { CoreComponentProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export type MenuProps = CoreComponentProps<MantineMenuProps, 'div'>;

function MenuRoot({ testId, view = 'all', ...rest }: MenuProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineMenu data-testid={testId} {...rest} />;
}

export const Menu = Object.assign(MenuRoot, {
  Target: MantineMenu.Target,
  Dropdown: MantineMenu.Dropdown,
  Item: MantineMenu.Item,
  Label: MantineMenu.Label,
  Divider: MantineMenu.Divider,
});
